/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEmrType } from './ExternalEmrType';
import {
    ExternalEmrTypeFromJSON,
    ExternalEmrTypeFromJSONTyped,
    ExternalEmrTypeToJSON,
    ExternalEmrTypeToJSONTyped,
} from './ExternalEmrType';

/**
 * 
 * @export
 * @interface ExternalEmrDocument
 */
export interface ExternalEmrDocument {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    type: ExternalEmrType;
    /**
     * 
     */
    external_document_id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    document_type: ExternalEmrDocumentDocumentTypeEnum;
    /**
     * 
     */
    document_type_display_name?: string | null;
    /**
     * 
     */
    discipline?: string | null;
    /**
     * 
     */
    status?: string | null;
    /**
     * 
     */
    is_esigned?: boolean | null;
    /**
     * 
     */
    is_finalized?: boolean | null;
    /**
     * 
     */
    is_active?: boolean | null;
    /**
     * 
     */
    has_change_history?: boolean | null;
    /**
     * 
     */
    key_date?: string | null;
    /**
     * 
     */
    start_date?: string | null;
    /**
     * 
     */
    end_date?: string | null;
    /**
     * 
     */
    completed_date?: string | null;
    /**
     * 
     */
    last_signed_date?: string | null;
    /**
     * 
     */
    external_facility_name?: string | null;
    /**
     * 
     */
    s3_key?: string | null;
    /**
     * Signed URL, injected at read time and valid for one hour
     */
    s3_access_url?: string;
    /**
     * 
     */
    content_type?: string | null;
    /**
     * 
     */
    filesize_in_bytes?: number | null;
    /**
     * 
     */
    page_count?: number | null;
    /**
     * Net Health lists the document but cannot produce the file, so it is shown for reference only: there is no s3_key and it cannot be included in a package.
     */
    is_render_unavailable?: boolean;
    /**
     * 
     */
    date_created?: string;
}


/**
 * @export
 */
export const ExternalEmrDocumentDocumentTypeEnum = {
    Eval: 'EVAL',
    Recert: 'RECERT',
    Pr: 'PR',
    Note: 'NOTE',
    Ten: 'TEN',
    Disch: 'DISCH',
} as const;
export type ExternalEmrDocumentDocumentTypeEnum = typeof ExternalEmrDocumentDocumentTypeEnum[keyof typeof ExternalEmrDocumentDocumentTypeEnum];


/**
 * Check if a given object implements the ExternalEmrDocument interface.
 */
export function instanceOfExternalEmrDocument(value: object): value is ExternalEmrDocument {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('external_document_id' in value) || value['external_document_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('document_type' in value) || value['document_type'] === undefined) return false;
    return true;
}

export function ExternalEmrDocumentFromJSON(json: any): ExternalEmrDocument {
    return ExternalEmrDocumentFromJSONTyped(json, false);
}

export function ExternalEmrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEmrDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ExternalEmrTypeFromJSON(json['type']),
        'external_document_id': json['external_document_id'],
        'name': json['name'],
        'document_type': json['document_type'],
        'document_type_display_name': json['document_type_display_name'] === undefined ? undefined : json['document_type_display_name'] === null ? null : json['document_type_display_name'],
        'discipline': json['discipline'] === undefined ? undefined : json['discipline'] === null ? null : json['discipline'],
        'status': json['status'] === undefined ? undefined : json['status'] === null ? null : json['status'],
        'is_esigned': json['is_esigned'] === undefined ? undefined : json['is_esigned'] === null ? null : json['is_esigned'],
        'is_finalized': json['is_finalized'] === undefined ? undefined : json['is_finalized'] === null ? null : json['is_finalized'],
        'is_active': json['is_active'] === undefined ? undefined : json['is_active'] === null ? null : json['is_active'],
        'has_change_history': json['has_change_history'] === undefined ? undefined : json['has_change_history'] === null ? null : json['has_change_history'],
        'key_date': json['key_date'] === undefined ? undefined : json['key_date'] === null ? null : json['key_date'],
        'start_date': json['start_date'] === undefined ? undefined : json['start_date'] === null ? null : json['start_date'],
        'end_date': json['end_date'] === undefined ? undefined : json['end_date'] === null ? null : json['end_date'],
        'completed_date': json['completed_date'] === undefined ? undefined : json['completed_date'] === null ? null : json['completed_date'],
        'last_signed_date': json['last_signed_date'] === undefined ? undefined : json['last_signed_date'] === null ? null : json['last_signed_date'],
        'external_facility_name': json['external_facility_name'] === undefined ? undefined : json['external_facility_name'] === null ? null : json['external_facility_name'],
        's3_key': json['s3_key'] === undefined ? undefined : json['s3_key'] === null ? null : json['s3_key'],
        's3_access_url': json['s3_access_url'] == null ? undefined : json['s3_access_url'],
        'content_type': json['content_type'] === undefined ? undefined : json['content_type'] === null ? null : json['content_type'],
        'filesize_in_bytes': json['filesize_in_bytes'] === undefined ? undefined : json['filesize_in_bytes'] === null ? null : json['filesize_in_bytes'],
        'page_count': json['page_count'] === undefined ? undefined : json['page_count'] === null ? null : json['page_count'],
        'is_render_unavailable': json['is_render_unavailable'] == null ? undefined : json['is_render_unavailable'],
        'date_created': json['date_created'] == null ? undefined : json['date_created'],
    };
}

export function ExternalEmrDocumentToJSON(json: any): ExternalEmrDocument {
    return ExternalEmrDocumentToJSONTyped(json, false);
}

export function ExternalEmrDocumentToJSONTyped(value?: ExternalEmrDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ExternalEmrTypeToJSON(value['type']),
        'external_document_id': value['external_document_id'],
        'name': value['name'],
        'document_type': value['document_type'],
        'document_type_display_name': value['document_type_display_name'],
        'discipline': value['discipline'],
        'status': value['status'],
        'is_esigned': value['is_esigned'],
        'is_finalized': value['is_finalized'],
        'is_active': value['is_active'],
        'has_change_history': value['has_change_history'],
        'key_date': value['key_date'],
        'start_date': value['start_date'],
        'end_date': value['end_date'],
        'completed_date': value['completed_date'],
        'last_signed_date': value['last_signed_date'],
        'external_facility_name': value['external_facility_name'],
        's3_key': value['s3_key'],
        's3_access_url': value['s3_access_url'],
        'content_type': value['content_type'],
        'filesize_in_bytes': value['filesize_in_bytes'],
        'page_count': value['page_count'],
        'is_render_unavailable': value['is_render_unavailable'],
        'date_created': value['date_created'],
    };
}

